import { render, staticRenderFns } from "./QuitProject.vue?vue&type=template&id=72aeabba&scoped=true&"
import script from "./QuitProject.vue?vue&type=script&lang=js&"
export * from "./QuitProject.vue?vue&type=script&lang=js&"
import style0 from "./QuitProject.vue?vue&type=style&index=0&id=72aeabba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aeabba",
  null
  
)

export default component.exports